export enum LookbackEnum {
  W1 = '1W',
  M1 = '1M',
  M3 = '3M',
  M6 = '6M',
  Y1 = '1Y',
}

export enum TenorEnum {
  W1 = '1W',
  M1 = '1M',
  M3 = '3M',
  M6 = '6M',
  M9 = '9M',
  Y1 = '1Y',
}

export enum MetricEnum {
  P10 = '10P',
  P25 = '25P',
  ATMF = 'ATMF',
  C25 = '25C',
  C10 = '10C',
  P5 = '5P',
  P15 = '15P',
  P20 = '20P',
  P30 = '30P',
  P35 = '35P',
  P40 = '40P',
  C5 = '5C',
  C15 = '15C',
  C20 = '20C',
  C30 = '30C',
  C35 = '35C',
  C40 = '40C',
}

export interface IVolRangeRequestParams {
  lookback: LookbackEnum;
  tenor: TenorEnum;
  metric: MetricEnum;
  format: string;
}

export interface IVolRangeResponse {
  current: Record<string, number>;
  low: Record<string, number>;
  p25: Record<string, number>;
  median: Record<string, number>;
  p75: Record<string, number>;
  high: Record<string, number>;
}

export interface IVolRangeItem {
  symbol: string;
  current: number;
  low: number;
  p25: number;
  median: number;
  p75: number;
  high: number;
}

export type VolRangeData = IVolRangeItem[];
